import { render, staticRenderFns } from "./ProductUbication.vue?vue&type=template&id=3d445dfb&scoped=true"
import script from "./ProductUbication.vue?vue&type=script&lang=js"
export * from "./ProductUbication.vue?vue&type=script&lang=js"
import style0 from "./ProductUbication.vue?vue&type=style&index=0&id=3d445dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d445dfb",
  null
  
)

export default component.exports